import { endpoint } from '../decorators/endpoint.decorator';
import { BaseViewModel } from './base-view-model';

@endpoint('Document')
export class DocumentFileViewModel extends BaseViewModel {
  public ContentBytes = '';
}
